import L from "leaflet";
import "leaflet.markercluster";
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import  regeneratorRuntime from "regenerator-runtime";

const spinner = '<div class="load-spin"><div></div><div></div><div></div><div></div></div>';

function calculateDistance(origin, destination) {
    /* Used for calculating distance between multiple coordinates */
    const earthRadius = 6371;

    const toRadians = (angle) => {
        return angle * (Math.PI / 180);
    };

    const lat1 = origin.lat;
    const lon1 = origin.lng;
    const lat2 = destination.lat;
    const lon2 = destination.lng;

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = earthRadius * c;
    return distance;
}

class PickStoreModalNew {
    constructor() {
        this.init();
    }

    /**
     * Main method. Used for setting up other methods
     * 
     */
    init() {
        let $ = jQuery;
        let self = this;

        $(document).ready(function () {
            /* Init leaflet map */
            let map = self.initMap();

            // Close to you button
            $('.close-to-you-new').click(function () {
                let btn = $(this);
                self.closeToYou(map, btn);
            });
            
            // Find store form
            $('#find-store-form-new').submit(function (e) {
                e.preventDefault();

                // Remove error message.
                jQuery('.error-no-shop').remove();

                self.bindSearchInput($('#find-store-input-new').val(), 10, map);
            });
        });
    }

    /**
     * Init leaflet map
     * 
     */
    initMap(){
        let $ = jQuery;

        if($('#ll-map-desktop').length == 0 && $('#ll-map-mobile').length == 0)
            return;

        /* Responsive map */
        if($(window).width() < 768) {
            var map = L.map('ll-map-mobile').setView([62.3910011, 16.7393019], 5);
            var markers = $('#ll-map-mobile').data('markers');
        } else {
            var map = L.map('ll-map-desktop').setView([62.3910011, 16.7393019], 6);
            var markers = $('#ll-map-desktop').data('markers');
        }
        
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 15,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        L.Marker.prototype.options.icon = L.icon({
            iconUrl: "/wp-content/themes/nordsjo-theme/resources/dist/images/map-pin.png",
        });

        /* Clusters and marker HTML */
        if(markers.length > 0) {
            var cluster = L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                zoomToBoundsOnClick: true
            });
            for (var i = 0; i < markers.length; i++) {
                cluster.addLayer(L.marker([
                    markers[i].lat, markers[i].lng
                ]).bindPopup(
                    '<div class="ll-popup">' +
                    '<h5>' + markers[i].content.name + '</h5>' +
                    '<p>' + markers[i].content.address + '</p>' +
                    '<a href="' + markers[i].content.siteurl + '">Till butiken</a>' +
                    '</div>'
                ));
                map.addLayer(cluster);
            }
        }
        
        return map;
    }

    /**
     * Close to you button
     * 
     */
    closeToYou(map, btn) {
        self = this;

        // Add spinner
        jQuery(btn).children().css('visibility', 'hidden');
        jQuery(btn).append(spinner);

        jQuery('.error-no-shop').remove();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                map.setView(pos, 10);

                self.showResult(self, pos);

                // Remove spinner
                jQuery(btn).children('.load-spin').remove();
                jQuery(btn).children().css('visibility', 'visible');
            },
            function(error) {
                if (error.code == error.PERMISSION_DENIED)
                jQuery('#find-store .search-store').after(
                    '<span class="error-no-shop">Platstjänst ej tillåten</span>'
                );

                // Remove spinner
                jQuery(btn).children('.load-spin').remove();
                jQuery(btn).children().css('visibility', 'visible');
            });



        } else {
            alert('Geolocation is not supported by this browser.');
        }
    }

    /**
     * Responsible for displaying results based on either search coordinates or positional coordinates
     * 
     * @param {this} self 
     * @param {object} origin 
     */
    showResult(self, origin) {
        let $ = jQuery;

        $('#find-store .store-card').each(function (i, el) {
            
            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden');
            }

            let destination = { lat: parseFloat($(this).data('lat')), lng: parseFloat($(this).data('lng')) };

            const distance = calculateDistance(origin, destination);

            if (distance > 100) {
                $(this).addClass('is-hidden');
            } 

            /* Sorts by distance */
            $('#find-store .store-card').sort(function (a, b) {
                let aDistance = calculateDistance(origin, { lat: parseFloat($(a).data('lat')), lng: parseFloat($(a).data('lng')) });
                let bDistance = calculateDistance(origin, { lat: parseFloat($(b).data('lat')), lng: parseFloat($(b).data('lng')) });

                return aDistance - bDistance;
            }).appendTo('#find-store .stores-wrapper');

        });

        /* Update amount */
        setTimeout(() => {
            let totalStoreNumber = $('#find-store .store-card').length;
            let filteredStoreNumber = $('#find-store .store-card:not(.is-hidden)').length;
            $('#find-store .number-of-stores').empty();
            $('#find-store .number-of-stores').text(`${filteredStoreNumber} av ${totalStoreNumber} butiker`);
        }, 1000 );
    }

    bindSearchInput(input, zoom = null, map) {
        const self = this;
        self.geoCodeSearch(input, zoom, map);
    }

    async geoCodeSearch(searchTerm, zoom = null, map = null) {

        // Add spinner
        jQuery('#find-store .search-store').find('.pre-input').children().css('visibility', 'hidden');
        jQuery('#find-store .search-store').find('.pre-input').append(spinner);

        const provider = new OpenStreetMapProvider({
            params: {
                countrycodes: "se",
            },
        });
        const results = await provider.search({ query: searchTerm });
        /* Serach result */
        setTimeout(() => {
            if (results.length > 0) {
                const pos = {
                    lat: results[0].y,
                    lng: results[0].x
                };

                if (zoom) {
                    map.setView(pos, zoom);
                } else {
                    map.setView(pos, 10);
                }

                this.showResult(self, pos);

                // Remove spinner
                jQuery('#find-store .search-store').find('.pre-input').children('.load-spin').remove();
                jQuery('#find-store .search-store').find('.pre-input').children().css('visibility', 'visible');
                
            } else {
                jQuery('#find-store .search-store').after('<span class="error-no-shop">Adressen kunde ej hittas</span>');

                // Remove spinner
                jQuery('#find-store .search-store').find('.pre-input').children('.load-spin').remove();
                jQuery('#find-store .search-store').find('.pre-input').children().css('visibility', 'visible');
            }
        }, 1000);
    }
}

export default PickStoreModalNew;
